import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Loader } from "@components/atoms";
import { TaxedMoney } from "@components/containers";
import { CartSummaryRow } from "@components/molecules";
import { checkoutMessages, commonMessages } from "@temp/intl";
import * as S from "./styles";
import { Link } from "react-router-dom";
import { cartUrl } from "@temp/app/routes";

var CostLine = function CostLine(_ref) {
  var name = _ref.name,
      cost = _ref.cost,
      _ref$last = _ref.last,
      last = _ref$last === void 0 ? false : _ref$last,
      _ref$negative = _ref.negative,
      negative = _ref$negative === void 0 ? false : _ref$negative;
  return React.createElement(S.CostLine, {
    last: last,
    negative: negative
  }, React.createElement("span", null, name), React.createElement("span", {
    "data-test": "cartSummaryCost".concat(name.replace(/\s/g, ""))
  }, negative && "- ", React.createElement(TaxedMoney, {
    taxedMoney: cost
  })));
};

var Costs = function Costs(_ref2) {
  var subtotal = _ref2.subtotal,
      promoCode = _ref2.promoCode,
      shipping = _ref2.shipping,
      total = _ref2.total;
  var intl = useIntl();
  return React.createElement(S.Costs, null, subtotal && React.createElement(CostLine, {
    name: intl.formatMessage(commonMessages.subtotal),
    cost: subtotal
  }), shipping && React.createElement(CostLine, {
    name: intl.formatMessage(commonMessages.shipping),
    cost: shipping
  }), promoCode && promoCode.gross.amount > 0 && React.createElement(CostLine, {
    name: intl.formatMessage(commonMessages.promoCode),
    cost: promoCode,
    negative: true
  }), React.createElement(S.HR, null), total && React.createElement(CostLine, {
    name: intl.formatMessage(commonMessages.total),
    cost: total,
    last: true
  }));
};
/**
 * Cart summary displayed in checkout page
 */


var CartSummary = function CartSummary(_ref3) {
  var subtotal = _ref3.subtotal,
      total = _ref3.total,
      shipping = _ref3.shipping,
      promoCode = _ref3.promoCode,
      products = _ref3.products;
  return React.createElement(S.Wrapper, null, (products === null || products === void 0 ? void 0 : products.length) > 0 ? React.createElement(React.Fragment, null, React.createElement(S.Header, {
    "data-test": "cartSummaryTitle"
  }, React.createElement(S.Title, null, React.createElement(FormattedMessage, checkoutMessages.cartSummary)), React.createElement(Link, {
    to: cartUrl
  }, React.createElement(Button, {
    color: "outline"
  }, "Modifier"))), React.createElement(S.Content, null, React.createElement(S.HR, null), React.createElement(S.CartSummaryProductList, null, products === null || products === void 0 ? void 0 : products.map(function (product, index) {
    return React.createElement("div", {
      key: product.sku
    }, React.createElement(S.ProductLine, null, React.createElement(CartSummaryRow, {
      index: index,
      sku: product.sku,
      quantity: product.quantity,
      name: product.name,
      variantName: product.variantName,
      price: product.price,
      thumbnail: product.thumbnail
    })), React.createElement(S.HR, null));
  })), React.createElement(Costs, {
    subtotal: subtotal,
    total: total,
    shipping: shipping,
    promoCode: promoCode
  }))) : React.createElement(S.Loading, null, React.createElement(Loader, null)));
};

export { CartSummary };